import { useEffect, useRef } from 'react'


/**
 *
 * @param {Function} fn
 * @param {Array} deps
 * @returns {boolean}
 */
const useLifecycle = (fn, deps) => {
  const ref = useRef(true)

  useEffect(() => {
    const isFirstRender = ref.current

    fn(isFirstRender)
    ref.current = false
  }, deps)

  return ref.current
}


export default useLifecycle
